var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconGroceries48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_18209)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4735 13.6551L16.1604 9.22485H21.5899L23.2768 13.6551C23.6999 14.7664 23.9168 15.9455 23.9168 17.1345V24.5026H13.8335V17.1345C13.8335 15.9455 14.0504 14.7664 14.4735 13.6551Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9192 6.16943H15.8316C15.1566 6.16943 14.6094 6.71664 14.6094 7.39166V8.00277C14.6094 8.67778 15.1566 9.22499 15.8316 9.22499H21.9192C22.5942 9.22499 23.1414 8.67778 23.1414 8.00277V7.39166C23.1414 6.71664 22.5942 6.16943 21.9192 6.16943Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.303 13.1604C22.9471 12.6838 23.8807 12.3743 24.8364 12.6129C25.4616 12.769 26.0964 13.4554 26.6658 13.4554C27.3228 13.4554 28.0502 12.761 28.7549 12.6236C29.7246 12.4344 30.6512 12.8378 31.2917 13.3659C32.6722 14.504 33.295 16.7419 33.0194 18.6256C32.6058 21.453 31.1022 23.6494 28.7908 24.4749C27.3832 24.6304 27.5728 24.0973 26.6658 24.0973C26.3493 24.0973 26.1667 24.1631 26.0026 24.2413L25.8636 24.3102C25.6031 24.4395 25.3051 24.5616 24.4983 24.4588C22.2102 23.621 20.7232 21.4348 20.3122 18.6256C20.0196 16.625 20.7719 14.2932 22.303 13.1604Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6398 9.83618C27.4467 9.83618 26.6069 10.6798 26.6069 12.8213",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3375 21.8984L24.435 22.975L25.518 21.891L27.4876 19.9194L30.5831 22.975L33.7276 19.9194L36.7022 22.975L36.75 42.8361H12V22.975L15.0938 19.9194L18.1841 22.975L21.3198 19.9194L23.3375 21.8984Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_18209"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconGroceries48);
export default __webpack_public_path__ + "static/media/pictogramBeaconGroceries48.677c64be6f353bf53038db1573c53c20.svg";
export { ForwardRef as ReactComponent };